<template>
  <AutocompleteCity
    class="selector"
    :placeholder="$t('citySelector.cities.placeholder')"
    icon-pack="fas"
    icon-right="chevron-down"
    :clearable="true"
    :keep-first="false"
    icon="map-marker-alt"
    typing-tracker-event="Typed in CitySelector"
    @select="handleCitySelected($event)"
    @focus="$trackers.trackClick('CitySelectorField')"
  />
</template>

<script>
import AutocompleteCity from "~/components/_refactored/autocomplete/AutocompleteCity.vue";

export default {
  components: { AutocompleteCity },

  methods: {
    handleCitySelected(event) {
      this.$trackers.trackClick("CitySelectorFieldItem");
      if (event && event.seoName) {
        this.$emit("select", event);
      } else {
        this.$emit("select", "");
      }
    },
  },
};
</script>
